import { NumberWithUnit } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";
import { LeverIndicatorGoal } from "./LeverIndicatorGoal";

type LeverIndicatorGoalsProps = {
    goals: LeverIndicatorGoal[];
};

export const LeverIndicatorGoals = (props: LeverIndicatorGoalsProps) => {
    const { goals } = props;
    const theme = useTheme();

    return (
        <Stack
            gap={theme.spacing(1)}
            sx={{
                alignSelf: "end",
                marginTop: "auto",
                ...(goals.length > 0 ?
                    {
                        borderTop: `1px solid ${theme.custom.grey[500]}`,
                        padding: theme.spacing(3.5),
                    }
                :   {}),
            }}
        >
            {goals.map((goal) => (
                <Stack key={goal.label} flexDirection="row" alignItems="baseline" gap={theme.spacing(1)}>
                    <Typography variant="body-medium">{goal.label}:</Typography>
                    <NumberWithUnit value={goal.value} unit={goal.unit} />
                </Stack>
            ))}
        </Stack>
    );
};
